export const getRecipeServingsMuliplier = (
  recipe: { default_servings?: number },
  servings?: number
): number => {
  if (!servings) return 1;

  const { default_servings = 1 } = recipe;

  if (servings === default_servings) return 1;

  return servings / default_servings;
};
